import {
  AUTHENTICATION_URL,
  FILE_UPLOAD_URL,
  BASE_URL,
} from "../src/constants/constants";
import {ethers} from "ethers";
import {transactionStore} from "../src/stores/transactionStore";
export const uploadImages = async (file) => {
  let formdata = new FormData();
  formdata.append("files", file, file.name);

  let requestOptions = {
    method: "POST",
    headers: {
      authorization: AUTHENTICATION_URL,
    },
    body: formdata,
    redirect: "follow",
  };

  return await fetch(FILE_UPLOAD_URL, requestOptions)
    .then((result) => {
      return result;
    })
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("error", error));
};

export const createProject = async (data) => {
  return await fetch(`${BASE_URL}/api/projects`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: AUTHENTICATION_URL,
    },
    body: JSON.stringify({
      data: data,
    }),
  })
    .then((result) => {
      return result;
    })
    .then((response) => {
      return response.json();
    });
};

export const updateProject = async (projectId, data) => {
  return await fetch(`${BASE_URL}/api/projects/${projectId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: AUTHENTICATION_URL,
    },
    body: JSON.stringify({
      data: data,
    }),
  });
};

export const getTransactionFee = async () => {
  let data = await fetch(`${BASE_URL}/api/platform-configurations`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: AUTHENTICATION_URL,
    },
  });
  let response = await data.json();
  if(response.data && response.data.length == 0) return;

  let txDetails = {
    recepientAddress: response.data[0].attributes.fee_recepient_address,
    percentageFee: response.data[0].attributes.fee_percentage,
  };

  if(ethers.utils.isAddress(txDetails.recepientAddress))
    transactionStore.set(txDetails)
};


